'use client'

import { logoutAndClearClientState } from '@/lib/logout'
import { recordAuthDebug, summarizeAuthProfile } from '@/lib/auth-debug'
import { fetchAuthMe } from '@/queries/auth'
import {
  bootstrapStartupRouteData,
  resolveCachedStartupRoute,
  resolveStartupRoute,
} from '@/lib/workspace-store'
import { useAuthStore } from '@/stores/auth-store'

type RouterLike = {
  replace: (href: string) => void
}

export async function syncAuthenticatedState() {
  const data = await fetchAuthMe()
  useAuthStore.getState().setAuthenticated({
    user: data.user,
    identity: data.identity,
    session: data.session,
  })
  const profileSummary = summarizeAuthProfile(data.user)
  if (profileSummary.birthNameLooksPlaceholder || !profileSummary.hasAvatarUrl) {
    recordAuthDebug('callback:session-profile-incomplete', {
      provider: data.identity.provider,
      ...profileSummary,
    })
  }
  return data
}

export async function routeToStartupDestination(router: RouterLike) {
  const cachedHref = resolveCachedStartupRoute()
  if (cachedHref) {
    // Returning user: redirect immediately from cache, warm data in background.
    void bootstrapStartupRouteData().catch((error) => {
      console.error('Could not warm startup route data', error)
    })
    router.replace(cachedHref)
    return
  }

  // No cached state: compute the real startup route so brand-new users can land
  // on onboarding instead of the empty people shell.
  try {
    router.replace(await resolveStartupRoute())
  } catch (error) {
    console.error('Could not resolve startup route', error)
    router.replace('/people')
  }
}
